import { distinctUntilChanged, filter } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'

import { UXFacet } from '../../models/ux-facets'
import { FacetToggleEvent } from '../../models/facet-toggle-event';

@Component({
  selector: 'app-facet',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacetComponent implements OnInit {
  applied: boolean = false

  @Input() facet: UXFacet
  @Input('is-applied') set isApplied(value: boolean) {
    this.applied = value
    this.checkBoxControl.setValue(value)
  }
  @Output() facetToggled = new EventEmitter<FacetToggleEvent>()

  checkBoxControl = new FormControl()

  get name(): (string | number) {
    return this.facet.name
  }

  get idByGroup(): string {
    return this.facet.group.trim() + this.facet.name.trim()
  }

  get count(): number {
    return this.facet.count
  }

  get notApplicable() {
    return !this.applied && this.count === 0
  }

  ngOnInit() {
    this.notApplicable
      ? this.checkBoxControl.disable()
      : this.checkBoxControl.enable()

    this.checkBoxControl.valueChanges.pipe(
      filter(value => value !== this.applied),
      distinctUntilChanged(),)
      .subscribe(this.toggled.bind(this))
  }

  toggled() {
    this.facetToggled.emit({
      code: this.facet.code,
      group: this.facet.group
    })
  }
}
